import { render, staticRenderFns } from "./Tabs.html?vue&type=template&id=21f35df4&scoped=true&"
import script from "./Tabs.js?vue&type=script&lang=js&"
export * from "./Tabs.js?vue&type=script&lang=js&"
import style0 from "./Tabs.scss?vue&type=style&index=0&id=21f35df4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f35df4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VFlex,VTab,VTabs,VTabsItems})
